import React from 'react';
import { Grid, Divider } from 'semantic-ui-react';
import './Company.css';
import { renderDataAsHtml, renderDataAsPlainText } from '../../api/renderPrismicData';
import withDataFetch from '../../api/withDataFetch';
import withFullScreenLoader from '../UtilityComponents/withFullScreenLoading';

const Company = ({
  data: {
    title,
    subtitle,
    paragraph,
    subtitle1,
    paragraph1,
  },
}) => {
  return (
    <Grid stackable className="Company">
      <Grid.Row columns="equal" centered>
        <h2 className="Page__Title">
          {renderDataAsPlainText(title)}
        </h2>
      </Grid.Row>
      <Divider />

      <Grid.Row className="Home__History">
        {renderDataAsHtml(subtitle)}
        {renderDataAsHtml(paragraph)}
      </Grid.Row>
      <Divider />
      <Grid.Row width={8}>
        {renderDataAsHtml(subtitle1)}
        {renderDataAsHtml(paragraph1)}
      </Grid.Row>
      <Divider />
    </Grid>
  );
};

export default withDataFetch(withFullScreenLoader(Company), 'organisati');



// WEBPACK FOOTER //
// ./src/components/Company/index.js